import { ISimpleFetch } from '../../interfaces';

const defaultOptions: RequestInit = {
  credentials: 'include',
  cache: 'no-cache',
  headers: {
    'Content-Type': 'application/json',
  },
};

const simpleFetch = ({
  uri,
  options = {},
  baseUrl = process.env.REACT_APP_API,
}: ISimpleFetch): Promise<any> =>
  fetch(`${baseUrl}${uri}`, { ...defaultOptions, ...options }).then((response) => {
    if (response.ok) {
      return response.text().then((text) => {
        try {
          return JSON.parse(text);
        } catch {
          throw new Error('Something went wrong');
        }
      });
    }

    throw response.text();
  });

const simplePost = async (url = '', data = {}, options = {}) => {
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    ...defaultOptions,
    ...options,
  });
  const parsedResponse = await response.json();
  if (!response.ok || parsedResponse?.error) throw parsedResponse;
  return parsedResponse;
};

export { simpleFetch, simplePost };
